/* tslint:disable */
/* eslint-disable */
/**
 * iEduBiofoundry API
 * **Namespacing.** Routes `/api/learn/_*`, tables `learn_*`, Python module `app/learning/`, Python classes prefixed `Learn*`. Within this namespace, \"Session\" means a *learning* Session — a facilitator-created event — never the research workspace in `app/models.py`.  **Three principals, never overlapping:**   * Facilitator — existing oauth2-proxy cookie or `X-API-Key`.   * Learner — `X-Learner-Token`, Visit-scoped, short TTL, heartbeat-renewed. Can write.   * Take-home — capability URL `/learn/me/{token}`. Read-only.  **Game data is opaque.** `LearnAttempt.state` and `LearnArtifact.payload` are arbitrary JSON owned by the frontend. The backend stores and returns them without inspection.  **The two learner tokens are stored differently, on purpose.** The visit token is hashed — it writes, it is short-lived, nobody needs it back. The take-home token is stored recoverably and is only seven characters, because it is read-only and is typed by hand off a printed card; the trade is spelled out in `API_DRAFT.md` §1 and D16.  **Call-by-call frontend walkthrough:** `API_WALKTHROUGH.md` — one Session, several Visits, every exchange in order, including the failure modes.  **Status.** Hand-authored ahead of implementation. Once `app/learning/` exists, FastAPI\'s generated schema becomes the source of truth and this file should be regenerated from it. 
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * Contact: mjberry@illinois.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TakeHomeLink
 */
export interface TakeHomeLink {
    /**
     * Render as a QR code and a printable card; do not email it — collecting a child's
     * email address at a kiosk is the largest compliance exposure in the design.
     * 
     * Short because it is typed by hand. Re-readable from `GET /learn/visits/me` after the
     * visit ends, so losing the tab is no longer fatal.
     * 
     */
    url: string;
    /**
     * Which participant this link is for.
     */
    label: string | null;
}

/**
 * Check if a given object implements the TakeHomeLink interface.
 */
export function instanceOfTakeHomeLink(value: object): value is TakeHomeLink {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function TakeHomeLinkFromJSON(json: any): TakeHomeLink {
    return TakeHomeLinkFromJSONTyped(json, false);
}

export function TakeHomeLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): TakeHomeLink {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'label': json['label'],
    };
}

export function TakeHomeLinkToJSON(json: any): TakeHomeLink {
    return TakeHomeLinkToJSONTyped(json, false);
}

export function TakeHomeLinkToJSONTyped(value?: TakeHomeLink | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'label': value['label'],
    };
}

